import React from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const TopUsedConditions = () => {
  const handlePanelChange = (key) => {
    console.log(`Active Panel Key: ${key}`);
  };

  return (
    <Collapse
      onChange={handlePanelChange}
      ghost
    >
      <Panel header="Example conditions" key="1">
      <b>Issue Conditions</b>
      <br/>Status is Done - <b>JSON Path:</b> $.issue.fields.status.name <b>Operand: </b>EQUALS <b>Value: </b>Done
      <br/>Reporter of issue - <b>JSON Path:</b> $.issue.fields.reporter.accountId<b> Operand: </b>EQUALS <b>Value: </b>ACCOUNT_ID
      <br/>User that triggered the change of an issue - <b>JSON Path:</b> $.user.accountId <b>Operand: </b>EQUALS <b>Value: </b>ACCOUNT_ID
      <p>Customfield of type text - <b>JSON Path:</b> $.issue.fields.customfield_xxxxx <b>Operand: </b>EQUALS <b>Value: </b>THE_TEXT_VALUE</p>
      <b>Attachment Conditions</b>
      <p>All attachment file - <b>JSON Path:</b> $.attachments.all.length <b>Operand: </b>GREATER THAN <b>Value: </b>0
      <br/>All unsent attachment file - <b>JSON Path:</b> $.attachments.unsent.length <b>Operand: </b>GREATER THAN <b>Value: </b>0
      <br/>First unsent attachment file - <b>JSON Path:</b> $.attachments.unsentFile.length <b>Operand: </b>GREATER THAN <b>Value: </b>0</p>

      </Panel>
    </Collapse>
  );
};

export default TopUsedConditions;